import styled from 'styled-components';

export const StyledLogoSlider = styled.div`
	.hm-clients {
		padding: 56px 0;
	}

	.swui-container {
		box-sizing: border-box;
		width: 100%;
		padding: 0 16px;
		margin: 0 auto;
	}

    .swui-h4 {
        font-family: "DM Sans", sans-serif;
        font-weight: 500;
        color: #092540;
        font-size: 1rem;
        line-height: 1.5
    }

	@media (min-width: ${({ theme }) => theme.tab}) {
		.hm-clients {
			padding: 10px 0;
		}

		.hm-clients__title {
			margin-bottom: 32px;
		}

		.hm-clients__logos {
			height: 96px;
		}

		.hm-clients__logo {
			height: 96px;
		}
		.swui-container {
			max-width: 1248px;
			padding-right: 24px;
			padding-left: 24px;
		}
        .swui-h4 {
            font-size: 1.5rem;
            line-height: 1.17
        }
	}
	}

	@media (min-width: ${({ theme }) => theme.mobile}) {
		.swui-container {
			max-width: 566px;
		}
	}

	.hm-clients__title {
		margin: 0 0 24px;
		text-align: center;
	}

	.hm-clients__logos {
		position: relative;
		height: 64px;
	}

	.hm-clients__track {
		display: flex;
		height: 100%;
		position: absolute;
		overflow-x: hidden;
		top: 0;
		left: 0;
		animation: hm-clients-track-move 30s linear infinite;
		will-change: transform;
	}

	.hm-clients__logo {
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		height: 64px;
		padding: 0 30px;
	}

	.hm-clients__image {
		max-width: 100%;
		width: auto;
	}

	.swui-container,
	.hm-hero__container {
		box-sizing: border-box;
		width: 100%;
		padding: 0 16px;
		margin: 0 auto;
	}

	@keyframes hm-clients-track-move {
		0% {
			transform: translate(20px);
		}
		100% {
			transform: translateX(-60%);
		}
	}
`;
